<template>
  <div>
    <v-row>
      <v-col class="py-2">
        <v-card color="transparent" tile flat>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="5" align="left" class="subtitle-2 pb-0">Name</v-col>
              <v-col cols="3" align="center" class="subtitle-2 pb-0">
                Role
              </v-col>
              <!-- User wiki is hidden for now -->
              <!-- <v-col cols="2" align="center" class="subtitle-2 pb-0">
                Wiki link
              </v-col> -->
              <v-col cols="3" align="center" class="subtitle-2 pb-0">
                Tasks
              </v-col>
              <v-col
                cols="1"
                align="right"
                class="subtitle-2 pb-0"
                v-if="$can('users.delete')"
              ></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="users.length">
      <v-col cols="12" v-for="user in users" :key="user.id">
        <users-table-item :user="user" />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <v-card outlined tile>
          <v-card-title class="subtitle-1">No users found.</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UsersTableItem from './UsersTableItem'

export default {
  name: 'UsersTable',
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  components: {
    UsersTableItem
  }
}
</script>
